import { useCallback, useState, useContext, useEffect } from "react"
import { AppContext } from "../base/app-context-provider.js"
import { Loader } from "widgets"
import { useService } from "utils"
import { initiateVisaModuleForAgency } from "./visaero-services.js"

const VisaeroAgentModule = ({ type = "issue" }) => {
  const { user } = useContext(AppContext)
  const [urls, isAgentModulePending, startInitiateAgentModule] = useService(
    initiateVisaModuleForAgency,
  )
  const [isLoading, setIsLoading] = useState(true)

  const onIframeLoad = useCallback(() => {
    setIsLoading(false)
  }, [])

  useEffect(() => {
    const fetchUrls = async () => {
      if (user.officeDTO.officeLevel !== 0 && type) {
        setIsLoading(true)
        await startInitiateAgentModule({
          data: {
            agency_id: user.visaeroAgencyId,
            agent_id: user.visaeroAgentId,
            host: "resbird",
            token: "test",
          },
        })
      }
      setIsLoading(false)
    }
    fetchUrls()
  }, [
    startInitiateAgentModule,
    type,
    user.officeDTO.officeLevel,
    user.visaeroAgencyId,
    user.visaeroAgentId,
  ])

  return (
    <div
      style={{ position: "relative", minHeight: "100%", width: "100%" }}
      className="visaero-portal"
    >
      {isLoading && <Loader />}
      {urls && !isAgentModulePending && (
        <iframe
          src={urls.data[type === "issue" ? "evm_url" : "evm_track_url"]}
          title="Visaero Login"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          onLoad={onIframeLoad}
        />
      )}
    </div>
  )
}

export default VisaeroAgentModule
